"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUnsupportedProxy = void 0;
const createUnsupportedProxy = () => {
    return new Proxy({}, {
        get(target, prop) {
            throw new Error(`Unsupported operation: Cannot access '${String(prop)}' - this context is not supported !!!`);
        },
        set(target, prop) {
            throw new Error(`Unsupported operation: Cannot set '${String(prop)}' - this context is not supported !!!`);
        },
        has(target, prop) {
            throw new Error(`Unsupported operation: Cannot check '${String(prop)}' - this context is not supported !!!`);
        },
        ownKeys() {
            throw new Error("Unsupported operation: Cannot enumerate properties - this context is not supported !!!");
        },
        getOwnPropertyDescriptor() {
            throw new Error("Unsupported operation: Cannot get property descriptor - this context is not supported !!!");
        },
    });
};
exports.createUnsupportedProxy = createUnsupportedProxy;
